import { useEffect, useRef, useState } from "react";
import { useAppContext } from "../functions/Context";
import { defaultScorecardMetadata, IScorecardMetadata } from "../models/ScorecardMetadata";

const useDepartmentScorecardMetadata = (departmentId: string): IScorecardMetadata => {

  const { store, api } = useAppContext();
  const [agreement, setAgreement] = useState<IScorecardMetadata>({ ...defaultScorecardMetadata });
  const firstRender = useRef(true);

  useEffect(() => {
    if (!firstRender.current) return;
    firstRender.current = false;

    const load = async () => {
      try {
        await api.departmentScorecardMetadata.getByUid(departmentId);
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, [api.departmentScorecardMetadata, departmentId]);

  useEffect(() => {
    const $agreement = store.departmentScorecardMetadata.getById(departmentId); //   get uid user, or me
    if (!$agreement) return;

    setAgreement({
      ...defaultScorecardMetadata,
      ...$agreement.asJson,
    });
  }, [
    departmentId,
    store.departmentScorecardMetadata,
    store.departmentScorecardMetadata.all,
  ]);

  const returnType: IScorecardMetadata = agreement;
  return returnType;
};

export default useDepartmentScorecardMetadata;
